<script>
    import Portal from "svelte-portal";
    export let displayPrice=false, dynAttr21='', isComingSoon=false, dynAttr295=''
    const lang	= document.querySelector('html').lang || 'en'
</script>

{#if displayPrice}
    {#if dynAttr295}
        <img src={`https://homehardware.sirv.com/hh/icons/LockedInLowPrice_${lang === 'fr' ? 'FR_' : ''}x50.svg`} alt="Locked-In-Price Logo" width="60" height="34" />
    {/if}
    {#if dynAttr21 && dynAttr21?.includes('Energy Star')}
        <img src="https://homehardware.sirv.com/hh/svg/EnergyStar_Blue_RGB_Logo.svg" alt="energy star logo" height="34" width="34" />
    {/if}
{:else}
    <section class="pdp-price Desktop">
        <div class="ProductFlags">
            {#if isComingSoon}
                <span class="PriceFlag">{lang=='en' ? 'Coming soon!' : 'Bientôt disponible !'}</span>
            {:else if dynAttr21 && dynAttr21?.includes('Energy Star')}
                <img src="https://homehardware.sirv.com/hh/svg/EnergyStar_Blue_RGB_Logo.svg" alt="energy star logo" height="34" width="34" />
            {/if}
        </div>
    </section>
    <Portal target="#portal_price">
        <section class="pdp-price">
            <div class="ProductFlags">
                {#if isComingSoon}
                    <span class="PriceFlag">{lang=='en' ? 'Coming soon!' : 'Bientôt disponible !'}</span>
                {:else if dynAttr21 && dynAttr21?.includes('Energy Star')}
                    <img src="https://homehardware.sirv.com/hh/svg/EnergyStar_Blue_RGB_Logo.svg" alt="energy star logo" height="34" width="34" />
                {/if}
            </div>
        </section>
    </Portal>
{/if}

<style>
    .pdp-price .ProductFlags {
        position: relative;
        transform: none;
    }
</style>